import React from 'react';
import { StarMark } from './Marks';

/** Our score out of 5, drawn as hand-made stars. Filled ones carry the rating. */
export function Rating({
  value,
  className = ''
}: {
  value: number;
  className?: string;
}) {
  return <span className={`inline-flex items-center gap-1.5 ${className}`} aria-label={`${value} av 5`} data-id="element-692" data-mp="v9uxs2igv7ji">
      <span className="flex gap-0.5" aria-hidden="true" data-id="element-693" data-mp="zd0zcwumwajn">
        {[1, 2, 3, 4, 5].map(step => <StarMark key={step} className={`h-4 w-4 ${value >= step - 0.5 ? 'text-rod' : 'text-black/20'}`} color="currentColor" data-id="element-694" data-mp="14ajckzfopbxg" />)}
      </span>
      <span className="text-[11px] font-bold uppercase tracking-wide2 text-black/50" data-id="element-695" data-mp="1e2go67alu5wp">
        {value.toString().replace('.', ',')}
      </span>
    </span>;
}